module.exports = __webpack_public_path__ + "img/event2412_5.b7d85264.png";